import React from "react";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {ButtonLinkStyle} from "../../../../Components/Inputs";
import {loanLibraryCatalogQueueModel} from "./loanLibraryQueueFactory";
import {LoanLibraryQueueItem} from "./LoanLibraryQueueItem";

interface LoanLibraryQueueListProps {
    handleDeselectAll?: () => void;
    handleRemoveFromQueue: (id: string) => void;
    handleSelectAll?: () => void;
    handleSelectedItemsChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    isPendingQueue?: boolean;
    queueItems: Record<string, any>[];
    selectedItems?: Set<string>;
}

export const LoanLibraryQueueList = ({
                                         handleDeselectAll,
                                         handleRemoveFromQueue,
                                         handleSelectAll,
                                         handleSelectedItemsChange,
                                         isPendingQueue = true,
                                         queueItems,
                                         selectedItems,
                                     }: LoanLibraryQueueListProps) => {

    const isLoanLibraryQueueEmpty = isArrayNullOrEmpty(queueItems);

    return <>
        <header>
            <h2> {isPendingQueue ? `Pending` : `Processing`}</h2>
        </header>
        {
            !isLoanLibraryQueueEmpty && handleSelectAll && handleDeselectAll &&
            <>
                <ButtonLinkStyle isCollapsed onClick={handleSelectAll} name={`btnSelectAll`}
                                 label={`Select All`}/> /&nbsp;
                <ButtonLinkStyle isCollapsed onClick={handleDeselectAll} name={`btnDeselectAll`}
                                 label={`Deselect All`}/>
            </>
        }
        {
            !isLoanLibraryQueueEmpty && queueItems &&
            queueItems.map((queueItem: Record<string, any>, index: number) => {

                const loanLibraryQueueId = queueItem.loanLibraryQueueId || '';
                const queueModel = loanLibraryCatalogQueueModel({...queueItem});
                const handleDelete = () => handleRemoveFromQueue(loanLibraryQueueId);
                const isSelected = selectedItems?.has(String(loanLibraryQueueId));

                return <LoanLibraryQueueItem
                    key={loanLibraryQueueId || `queue-item-${index}`}
                    {...queueModel}
                    loanLibraryCatalogItemId={String(queueModel.loanLibraryCatalogItemId ?? '')}
                    productName={String(queueModel.productName ?? '')}
                    loanLibraryQueueId={loanLibraryQueueId}
                    handleDelete={handleDelete}
                    handleSelectedItemsChange={handleSelectedItemsChange}
                    isPendingQueue={isPendingQueue}
                    isSelected={isSelected}
                />;
            })
        }
        {
            isLoanLibraryQueueEmpty &&
            <p className={`text-center`}>No results.</p>
        }
        <br/>
        <br/>
    </>;
};

